import * as React from 'react';
import { Route, Redirect, Switch, Router } from 'react-router-dom';
import { state } from '../framework/state';
import { AppLayout } from './AppLayout';
import { Dashboard } from './Dashboard';
import { Logout } from './Logout';
import { Parcel } from './../framework/Parcel';
import { Location } from 'history';
import { Inject } from '@symbiotic/green-state';
import { AppHistory } from '../framework/AppHistory';

// HACK: eliminate console warning resulting from incorrect prop types in react-router
// TODO: remove this hack after we update to react-router 4.4.0 or later
import * as PropTypes from 'prop-types';

if ((Route as any).propTypes) {
  (Route as any).propTypes.path = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
}

namespace AppRouter {
  export interface Props {
  }
  export interface State {
  }
}

export class AppRouter extends React.Component<AppRouter.Props, AppRouter.State> {
  render() {
    const routes = [] as JSX.Element[];

    state.pages.forEach(({ path, parcelConfig }) => {
      const parcel = <Parcel config={parcelConfig} />;
      routes.push((<Route key={path} path={path} exact={true} children={parcel} />));
    });

    return (
      <Inject diKey={AppHistory}>
        {(history) => (
          <Router history={history}>
            <Switch>
              <Route
                path="/logout"
                exact={true}
                component={Logout}
              />
              <Route
                path="/"
                exact={true}
                render={({ location }: { location: Location }) => (
                  <Redirect to={{ pathname: '/home', search: location.search }} />
                )}
              />
              <Route
                path="/home"
                exact={true}
                component={Dashboard}
              />
              <Route
                path={'/'}
                exact={false}
                render={(props) => (
                  <AppLayout {...props}>
                    <Switch>
                      {...routes}
                    </Switch>
                  </AppLayout>
                )}
              />
            </Switch>
          </Router>
        )}
      </Inject>

    );
  }
}



// WEBPACK FOOTER //
// ./src/portal-react-app/AppRouter.tsx